export default async function getChartData(service, days) {

    const response = await fetch(`api/ifblock/${service}?days=${days}`);
    const data = await response.json();
    return data;
}